import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CheckCurrencyHero } from '@root/features/premium/check-currency'

import { CurrencyCheckResult } from './currency-check-result'
import { PremiumHeroSlider } from './premium-unauthorized-slider'

import type { CheckCurrencyReatom } from '@root/features/premium'

export const PREMIUM_HERO_WIDTH = 650

type Props = {
  model: CheckCurrencyReatom
}

export const PremiumUnauthorizedCurrencyCheck: React.FC<Props> = ({
  model,
}) => {
  const { t } = useTranslation()

  const [state] = useAtom(model.checkCurrencyStateAtom)

  const renderResult = () => {
    if (!AsyncStateN.isSuccess(state)) {
      return <PremiumHeroSlider />
    }

    return <CurrencyCheckResult model={model} result={state.value} />
  }

  return (
    <Root>
      <Box>
        <Search>
          <Title>{t('premium.search.title')}</Title>
          <CheckCurrencyHero model={model} />
        </Search>
        {renderResult()}
      </Box>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 15px;

  width: ${PREMIUM_HERO_WIDTH}px;
`

const Box = styled.div`
  border-radius: 10px;
  background: rgba(var(--appearance-inv-1-rgb), 0.04);

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 380px;
`

const Search = styled.div`
  border: 1px solid rgba(var(--appearance-inv-1-rgb), 0.11);
  backdrop-filter: blur(17.5px);
  background: var(--backgroundA-3);

  border-radius: 10px;
  display: grid;

  padding: 14px;
  gap: 10px;
  flex-shrink: 0;
`

const Title = styled.div`
  color: var(--text-12);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`
